(function () {
  'use strict';

  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── SCROLL REVEAL ──────────────────────────────────────────────────────────
  function initReveal() {
    var sections = document.querySelectorAll('#MainContent .shopify-section');
    if (!sections.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove('sr-hidden');
          entry.target.classList.add('sr-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07 });

    sections.forEach(function (el) {
      el.classList.add('sr-hidden');
      observer.observe(el);
    });
  }

  // ── PARALLAX ───────────────────────────────────────────────────────────────
  function initParallax() {
    if (isMobile || prefersReduced) return;

    var targets = [];
    var vh = window.innerHeight;

    document.querySelectorAll('.image-with-text__media img').forEach(function (el) {
      targets.push({ el: el, factor: 0.22 });
    });

    document.querySelectorAll('.banner__media img, .hero__media img').forEach(function (el) {
      targets.push({ el: el, factor: 0.18 });
    });

    if (!targets.length) return;

    var ticking = false;

    window.addEventListener('resize', function () { vh = window.innerHeight; }, { passive: true });

    function update() {
      targets.forEach(function (t) {
        var rect = t.el.getBoundingClientRect();
        var centre = rect.top + rect.height * 0.5 - vh * 0.5;
        var offset = centre * t.factor;
        t.el.style.transform = 'translateY(' + offset.toFixed(2) + 'px)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  // ── ACCORDION ANIMATION ────────────────────────────────────────────────────
  function animateAccordion(details) {
    var summary = details.querySelector('summary');
    var content = details.querySelector('.accordion__content');
    if (!summary || !content) return;

    var animation = null;
    var isClosing = false;
    var isExpanding = false;
    var DURATION = 380;
    var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

    function onFinish(open) {
      details.open = open;
      animation = null;
      isClosing = false;
      isExpanding = false;
      details.style.height = '';
      details.style.overflow = '';
    }

    function shrink() {
      isClosing = true;
      var startH = details.offsetHeight + 'px';
      var endH   = summary.offsetHeight + 'px';
      if (animation) animation.cancel();
      animation = details.animate({ height: [startH, endH] }, { duration: DURATION, easing: EASING });
      animation.onfinish = function () { onFinish(false); };
      animation.oncancel = function () { isClosing = false; };
    }

    function expand() {
      details.style.height = details.offsetHeight + 'px';
      details.open = true;
      requestAnimationFrame(function () {
        isExpanding = true;
        var startH = details.offsetHeight + 'px';
        var endH   = (summary.offsetHeight + content.offsetHeight) + 'px';
        if (animation) animation.cancel();
        animation = details.animate({ height: [startH, endH] }, { duration: DURATION, easing: EASING });
        animation.onfinish = function () { onFinish(true); };
        animation.oncancel = function () { isExpanding = false; };
      });
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      details.style.overflow = 'hidden';
      if (isClosing || !details.open) {
        expand();
      } else {
        shrink();
      }
    });
  }

  function initAccordions() {
    if (prefersReduced) return;
    document.querySelectorAll('.collapsible-content .accordion details').forEach(animateAccordion);
  }

  // ── INIT ───────────────────────────────────────────────────────────────────
  function init() {
    initReveal();
    initParallax();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
